import { useState, useEffect } from 'react';
import { WrappedNativeTokens } from '@shared/types/quoting-engine/wrappedNativeTokens';
import { TradeMode } from '@shared/types/frontend/trade';
import { CovalentBalanceItem } from '@shared/types/frontend';
import usePortfolioBalance from '@/hooks/portfolio/usePortfolioBalance';
import TradeButtons from './TradeButtons';
import { isNativeTokenAddress } from '@/lib/asset/nativeAddressHelper';
const MobileBuySellController = ({
  setTradeMode,
  setSwapModalOpen,
  asset,
  balance
}: {
  setTradeMode: (mode: TradeMode) => void;
  setSwapModalOpen: (value: boolean) => void;
  asset: CovalentBalanceItem;
  // From Portfolio page props (because we already have the balance there)
  balance?: string;
}) => {
  const {
    data: portfolioBalance
  } = usePortfolioBalance({});
  const [tokenBalance, setTokenBalance] = useState(0);

  // Get asset balance
  useEffect(() => {
    if (balance === undefined) {
      const tokenInAssetData = portfolioBalance?.balances.find((x: CovalentBalanceItem) => {
        if (x.contract_address?.toLowerCase() === asset.contract_address?.toLowerCase() && x.network == asset.network) {
          return true;
        }
        if (isNativeTokenAddress(asset.contract_address) && asset.contract_address?.toLowerCase() == WrappedNativeTokens.get(asset.network)?.toLowerCase() && x.network == asset.network) {
          return true;
        }
        return false;
      });
      setTokenBalance(parseFloat(tokenInAssetData?.balance || '0'));
    } else {
      setTokenBalance(parseFloat(balance));
    }
  }, [balance, portfolioBalance]);
  return <div className='w-full' data-sentry-component="MobileBuySellController" data-sentry-source-file="MobileBuySellController.tsx">
      <TradeButtons setTradeMode={setTradeMode} showSellButton={!!tokenBalance} setIsModalOpen={setSwapModalOpen} data-sentry-element="TradeButtons" data-sentry-source-file="MobileBuySellController.tsx" />
    </div>;
};
export default MobileBuySellController;